<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content [formGroup]="form">
  <mat-tab-group
    *ngIf="actionListsStoreService.actionLists$ | async as actionLists; else loadingActionLists"
    [selectedIndex]="selectedIndex"
    (selectedIndexChange)="selectedIndex = $event"
  >
    <mat-tab
      [label]="'ACTION_LISTS.ADD_TO_LIST_DIALOG.ADD_TO_EXISTING_LIST' | translate"
      *ngIf="(actionLists || []).length > 0"
    >
      <div class="tab-container">
        <mat-form-field class="new-list-input">
          <input
            type="text"
            [placeholder]="'ACTION_LISTS.ADD_TO_LIST_DIALOG.SEARCH_OR_SELECT_LIST' | translate"
            matInput
            [formControl]="myControl"
            [matAutocomplete]="auto"
          />
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
            <mat-option *ngFor="let list of filteredLists$ | async" [value]="list">
              {{ list.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </mat-tab>
    <mat-tab [label]="'ACTION_LISTS.ADD_TO_LIST_DIALOG.CREATE_NEW_LIST' | translate">
      <div class="tab-container">
        <mat-form-field class="new-list-input">
          <input
            matInput
            [placeholder]="'ACTION_LISTS.ADD_TO_LIST_DIALOG.ENTER_A_LIST_NAME' | translate"
            formControlName="createNewList"
            (keypress)="keyPressed($event)"
            type="text"
          />
        </mat-form-field>
      </div>
    </mat-tab>
  </mat-tab-group>
  <ng-template #loadingActionLists>
    <div class="centered-spinner">
      <mat-spinner [diameter]="32" [strokeWidth]="4" [style.height.px]="32"></mat-spinner>
    </div>
  </ng-template>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button matDialogClose>
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button
    mat-raised-button
    button
    *ngIf="!loading"
    [disabled]="form.controls[this.CREATE_NEW_LIST].value === '' && !selectedList"
    (click)="addToList()"
    color="primary"
  >
    {{ submitText }}
  </button>
  <mat-spinner *ngIf="loading" [diameter]="32" [strokeWidth]="4" [style.height.px]="32"></mat-spinner>
</mat-dialog-actions>
